import { render, staticRenderFns } from "./FormerNames.vue?vue&type=template&id=15af9a90&"
import script from "./FormerNames.vue?vue&type=script&lang=js&"
export * from "./FormerNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports